import Tibbit_40_1 from '@appblocks/codegeneration/Tibbits/Tibbit_40_1';

export default class Tibbit_40_3 extends Tibbit_40_1 {
    constructor() {
        super();
        this.id = 'tibbit_40_3';
        this.name = 'Tibbit 40_3';
        this.range = 50000;
    }
}
